import { QueryWithViewMode } from 'src/utils/eventQueryUtils';
import { useContextSelector } from 'use-context-selector';

import {
  createFilterQueryContextWithSelector,
  IFilterQueryContext,
} from './FilterQueryContext';

const useContextValueSelector = <T, TQuery extends QueryWithViewMode>(
  selector: (context: IFilterQueryContext<TQuery>) => T
): T => {
  const contextValue = useContextSelector(
    createFilterQueryContextWithSelector<TQuery>(),
    selector
  );

  return contextValue;
};

export const useFilterQueryContextFilterQuerySelector = <
  T extends QueryWithViewMode,
>(): [T, (query: T) => void] => {
  const filterQuery = useContextValueSelector(
    (context) => context.filterQuery as T
  );
  const setFilterQuery = useContextValueSelector(
    (context) => context.setFilterQuery
  );
  return [filterQuery, setFilterQuery] as const;
};

export const useFilterQueryContextIsQueryInitializedSelector = (): boolean => {
  return useContextValueSelector((context) => context.isQueryInitialized);
};
